import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getCrewMaterials(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `events/${eventId}/crew-member-materials?${parameters}`
  );
  return data;
}

export async function getCrewMaterial(eventId, id) {
  const { data } = await axios.get(
    `events/${eventId}/crew-member-materials/${id}`
  );
  return data;
}

export async function getCrewMemberMaterial(eventId, barcode) {
  const { data } = await axios.get(
    `/events/${eventId}/crew-members/${barcode}/materials`
  );
  return data;
}

export async function createCrewMaterial(eventId, values) {
  const { data } = await axios.post(
    `events/${eventId}/crew-member-materials`,
    values
  );
  return data;
}

export async function updateCrewMaterial(eventId, id, values) {
  const { data } = await axios.patch(
    `events/${eventId}/crew-member-materials/${id}`,
    values
  );
  return data;
}

export async function deleteCrewMaterial(eventId, id) {
  const { data } = await axios.delete(
    `events/${eventId}/crew-member-materials/${id}`
  );
  return data;
}

export async function getCrewMaterialPickups(crewMemberId) {
  const { data } = await axios.get(
    `/crew-members/${crewMemberId}/material-pickups`
  );
  return data;
}

export async function createCrewMaterialPickup(crewMemberId, values) {
  const { data } = await axios.post(
    `/crew-members/${crewMemberId}/material-pickups`,
    values
  );
  return data;
}
